<grid-virtual-scroll-viewport class="main-grid">
    <div *gridVirtualFor="let rows of folderListDataSource; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
        <div *ngFor="let item of rows;" class="columns">
            <folder-card [folder]="item" (goToFolder)="goToFolder.emit($event)"></folder-card>
        </div>
    </div>
</grid-virtual-scroll-viewport>
